<template>
  <div style="margin: 30px auto 0; padding: 40px 0">
    <p class="findPwdTitle">
      {{ $t('找回密码') }}
    </p>
    <a-form-model ref="ruleForm" style="width: 100%" :model="form" :rules="rules">
      <a-form-model-item prop="phone">
        <a-input v-model="form.phone" :placeholder="$t('请输入手机号/邮箱')" size="large" />
      </a-form-model-item>
      <a-form-model-item prop="verifycode">
        <a-input v-model="form.verifycode" class="verifycode-left" :placeholder="$t('请输入验证码')" size="large" />
        <a-button class="verifycode" size="large" :disabled="state.smsSendBtn" @click="beforeSendCode">
          {{ (!state.smsSendBtn && `${$t('获取验证码')}`) || state.time + ' s' }}
        </a-button>
      </a-form-model-item>
      <a-popover
        v-model="state.passwordLevelChecked"
        placement="right"
        :trigger="['focus']"
        :get-popup-container="(trigger) => trigger.parentElement"
      >
        <template #content>
          <div :style="{ width: '240px' }">
            <div :class="['user-register', passwordLevelClass]">
              强度：<span>{{ passwordLevelName }}</span>
            </div>
            <a-progress :percent="state.percent" :show-info="false" :stroke-color="passwordLevelColor" />
            <div style="margin-top: 10px">
              <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-model-item prop="password">
          <a-input-password
            v-model="form.password"
            :placeholder="$t('请设置密码（6-18位）')"
            size="large"
            @click="state.passwordLevelChecked = true"
            @blur="state.passwordLevelChecked = false"
          />
        </a-form-model-item>
      </a-popover>
      <a-form-model-item prop="password2">
        <a-input-password v-model="form.password2" :placeholder="$t('请再次确认密码')" size="large" />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" size="large" block :loading="loading" @click="onSubmit">
          {{ $t('修改并登录') }}
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <vImgCode :visible.sync="imgCodeFlag" :phone="form.phone" @confimCode="confimCode" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import vImgCode from '@/components/business/imgCodeValidate'
import { encryption } from '@/utils/util'
import { phonePattern, emailPattern } from '@/const/pattern'
import { getResetSmsCaptcha, resetpass } from '@/api/login'
const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强',
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success',
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a',
}
export default {
  components: {
    vImgCode,
  },
  layout: 'logoTitle',
  props: {},
  data() {
    return {
      loading: false,
      form: {
        phone: '',
        verifycode: '',
        password: '',
        password2: '',
        protocol: [],
      },
      state: {
        time: 120,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000',
      },
      isPhone: false,
      imgCodeFlag: false,
      registerBtn: false,
      rules: {
        phone: [
          {
            required: true,
            validator: this.handlePhone,
            trigger: 'blur',
          },
        ],
        verifycode: [
          {
            required: true,
            message: this.$t('请输入验证码'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            validator: this.handlePasswordLevel,
            trigger: ['change', 'blur'],
          },
        ],
        password2: [
          {
            required: true,
            validator: this.handlePasswordCheck,
            trigger: 'blur',
          },
        ],
        protocol: [
          {
            type: 'array',
            required: true,
            message: this.$t('请阅读勾选协议'),
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel]
    },
  },
  mounted() {
    // 如果userInfo.phone存在, 则直接填充到表单中
    if (this.userInfo?.phone) {
      this.form.phone = this.userInfo.phone
    }
  },
  methods: {
    // 手机号验证
    handlePhone(rule, value, callback) {
      console.log('手机号码', value)
      if (value === '') {
        return callback(new Error(this.$t('请输入手机号码或邮箱')))
      }
      if (!phonePattern.test(value) && !emailPattern.test(value)) {
        return callback(new Error(this.$t('请输入正确的手机号码或邮箱！')))
      }
      callback()
    },
    // 密码验证
    handlePasswordLevel(rule, value, callback) {
      console.log('密码验证', typeof value, value)
      let level = 0
      if (value === undefined) {
        return callback(new Error(this.$t('请输入密码')))
      }
      console.log(value.length)
      if (value.length < 6) {
        return callback(new Error(this.$t('请输入至少6个字符')))
      }
      if (value.length > 18) {
        callback(new Error(this.$t('不能超过18位字符')))
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        const password2 = this.form.password2
        if (value && password2 && value.trim() === password2.trim()) {
          this.$refs.ruleForm.validateField(['password2'])
        }
        callback()
      } else {
        if (level === 0) {
          this.state.percent = 10
        }
        callback(new Error(this.$t('密码强度不够,不能纯数字或者纯字母')))
      }
    },
    // 密码再次验证
    handlePasswordCheck(rule, value, callback) {
      console.log('密码再次验证', value)
      const password = this.form.password
      console.log('password', password)
      if (!value) {
        callback(new Error(this.$t('请再次输入密码')))
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error(this.$t('两次密码不一致')))
      }
      callback()
    },
    // 找回密码
    onSubmit() {
      const {
        form: { phone, verifycode, password, password2 },
      } = this

      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          // 重置密码接口
          console.log(phone, verifycode, password, password2)
          const encodepassword = encryption(password)
          const data = await resetpass({
            channel: '',
            loginname: phone,
            password: encodepassword,
            repassword: encodepassword,
            verifycode,
          })
          this.loading = false
          console.log('找回密码接口返回', data)
          if (data.code === 0) {
            this.$message.success(data.msg || '密码修改成功')
            this.toLogin()
          } else {
            this.$message.error(data.msg)
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // TODO 登录逻辑, 照搬login的, 后期优化
    toLogin() {
      const {
        form: { phone, password },
      } = this

      const userInput = {}
      userInput.username = phone
      userInput.password = password
      userInput.grant_type = 'password'
      userInput.scope = 'server'

      // 注册后-自动登录
      this.$store
        .dispatch('loginByUsername', userInput)
        .then((msg) => {
          if (msg) {
            this.$message.error(msg)
          } else if (this.backPath === 'reload') {
            this.$router.go(0)
          } else {
            this.$store
              .dispatch('getUserInfo')
              .then(() => {
                this.$initWebIM({ status: 'normalLogin' })
                this.$store.commit('switchPopupLoginStatus', false)
              })
              .catch((e) => {
                // TODO 异常处理
                console.log(e)
              })
          }
        })
        .catch((e) => {
          console.log('catch', e)
          // TODO 异常处理
          this.$serverError()
        })
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    // 发送手机验证码-前
    beforeSendCode() {
      const {
        form: { phone },
      } = this
      console.log('发送验证码', phone)
      this.isPhone = false
      this.$refs.ruleForm.validateField(['phone'], (err) => {
        if (!err) {
          this.sendCode()
        }
      })
    },
    // 发送验证码
    async sendCode(flag = true) {
      const {
        form: { phone },
        state,
        $message,
        $notification,
      } = this
      state.smsSendBtn = true
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 120
          state.smsSendBtn = false
          window.clearInterval(interval)
        }
      }, 1000)

      if (flag) {
        const hide = $message.loading(this.$t('验证码发送中'), flag ? 0 : 1000)
        const data = await getResetSmsCaptcha(phone)
        console.log('获取验证码响应', data)
        if (data.code === 0 || data.code === 200) {
          setTimeout(hide, 2000)
          $notification.success({
            message: this.$t('提示'),
            description: this.$t('验证码发送成功,请注意查看'),
            duration: 8,
          })
        } else {
          setTimeout(hide, 1)
          clearInterval(interval)
          state.time = 120
          state.smsSendBtn = false
        }
      }
    },
    // 图形验证码输入正确后
    confimCode(a) {
      this.imgCodeFlag = false
      this.sendCode(false)
    },
    requestFailed(err) {
      this.$notification.error({
        message: '错误',
        description: ((err.response || {}).data || {}).message || '请求出现错误,请稍后再试',
        duration: 4,
      })
      this.registerBtn = false
    },
  },
}
</script>
<style lang="scss" scoped>
.findPwdTitle {
  font-size: 16px;
  font-weight: 600;
  color: #ff6600;
  line-height: 16px;
}

.verifycode-left {
  width: 50%;
}

.verifycode {
  width: 48%;
  float: right;
}

.en {
  .verifycode-left {
    width: 43%;
  }

  .verifycode {
    width: 55%;
    font-size: 13px;
  }
}
</style>
